import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BACK_CAPTIONS = {
    back: (
        <FormattedMessage
            id='back.caption_back'
            defaultMessage='НАЗАД'
        />
    ),
    close: (
        <FormattedMessage
            id='back.caption_close'
            defaultMessage='ЗАКРЫТЬ'
        />
    ),
    stronghold: (
        <FormattedMessage
            id='back.caption_stronghold'
            defaultMessage='К Укрепрайону'
        />
    ),
}

export const BACK_TYPES = {
    back: 'back',
    info: 'info',
    close: 'close',
}

export const BACK_SIDES = {
    right: 'right',
    left: 'left',
}



// WEBPACK FOOTER //
// ./components/Back/constants.jsx